<template>
  <div class="block absolute top-0 right-0">
    <UButton
      :disabled="disabled"
      color="white"
      variant="ghost"
      size="xl"
      icon="i-heroicons-x-mark"
      :aria-label="$t('a11y.close')"
      @click="$emit('close')"
    />
  </div>
</template>

<script setup lang="ts">
export interface propsInterface {
  disabled?: boolean
}

withDefaults(defineProps<propsInterface>(), {
  disabled: false,
})

defineEmits(['close'])
</script>
